export {};

declare global {
  interface Array<T> {
    /**
     * Extension method performing group by operation based on a key 
     * @param property The key to perform group by on.
     * @returns Map with property as the key and an array belonging or having the key.
     */
    groupBy<TProperty extends keyof T>(property: TProperty): { [key: string]: T[] };
  }
}


Array.prototype.groupBy = function<T, TProperty extends keyof T>(property: TProperty) {
  const result: { [key: string]: T[] } = {};

  for (const item of this) {
    const propertyValue = item[property] as any;
    if (!result[propertyValue]) {
      result[propertyValue] = [];
    }
    result[propertyValue].push(item);
  }

  return result;
};
